import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import auth from './auth'
import user from './user'
import global from './global'
import software from './software'
import standard from './standard'
import standardSection from './standardSection'
import attributeType from './attributeType'
import vulnerability from './vulnerability'
import checkpoint from './checkpoint'
import cwe from './cwe'
import assessor from './assessor'
import sourceScraper from './sourceScraper'
import scraper from './scraper'
import secondaryScraper from './secondaryScraper'
import scraperBuilder from './scraper-builder'

export default new Vuex.Store({
  modules: {
    auth,
    user,
    global,
    software,
    standard,
    standardSection,
    attributeType,
    vulnerability,
    checkpoint,
    cwe,
    assessor,
    sourceScraper,
    scraper,
    secondaryScraper,
    scraperBuilder
  }
})
